import { AppointmentType, AvailabilityType } from '../../constants'
import { Theme } from './types'

const transparency = '99'

const availabilityTheme: Record<AvailabilityType, Theme> = {
  [AvailabilityType.AVAILABLE]: {
    accent: '#66a1ec',
    background: '#d4dfed',
    foreground: '#000000',
  },
  [AvailabilityType.UNAVAILABLE]: {
    accent: '#ff8781',
    background: `#ffd7d5${transparency}`,
    foreground: '#000000',
  },
}

const appointmentTypeTheme: Record<AppointmentType | 'MULTIPLE', Theme> = {
  [AppointmentType.AFTERCARE_FOLLOW_UP]: {
    accent: '#8fd14f',
    background: `#dfffc0${transparency}`,
    foreground: '#000000',
  },
  [AppointmentType.EXTENDED_FOLLOW_UP]: {
    accent: '#12cdd4',
    background: `#dfffc0${transparency}`,
    foreground: '#000000',
  },
  [AppointmentType.FINAL_APPOINTMENT]: {
    accent: '#12cdd4',
    background: `#dfffc0${transparency}`,
    foreground: '#000000',
  },
  [AppointmentType.FOLLOW_UP]: {
    accent: '#12cdd4',
    background: `#b0eef1${transparency}`,
    foreground: '#000000',
  },
  [AppointmentType.HEARING_AID_EVALUATION]: {
    accent: '#2d9bf0',
    background: `#b9defa${transparency}`,
    foreground: '#000000',
  },
  [AppointmentType.VIDEO_CARE_CALL]: {
    accent: '#fac710',
    background: `#fcecb0${transparency}`,
    foreground: '#000000',
  },
  ['MULTIPLE']: {
    accent: '#888888',
    background: `#d7d7d7${transparency}`,
    foreground: '#000000',
  },
}

const NEVER_FREQUENCY = 'FREQ=DAILY;INTERVAL=1;COUNT=1'
const MINIMAL_TIME_BLOCK_IN_MINUTES = 15
const RULE_FREQUENCY_DELIMITER = '\nRRULE:'
const UTC_TIME_ZONE = 'etc/UTC'

export { MINIMAL_TIME_BLOCK_IN_MINUTES, NEVER_FREQUENCY, RULE_FREQUENCY_DELIMITER, UTC_TIME_ZONE, appointmentTypeTheme, availabilityTheme }
